export default __webpack_public_path__ + "static/media/main-balance.2d2ea93e.svg";